import { arrayOf, number, shape, string } from "prop-types"

export const linearLocation = shape({
    end: number.isRequired,
    road: string.isRequired,
    start: number.isRequired,
    typeid: number.isRequired,
})

export const linearLocations = arrayOf(shape({
    end: number.isRequired,
    road: string.isRequired,
    start: number.isRequired,
    typeid: number.isRequired,
}))